/**
 * ListView 的对外函数
 *
 * 主资源交给 ListViewFactory
 * 嵌套资源交给 NestedListViewFactory
 * 平行资源交给 ParallelListViewFactory
 *
 * 三个类的返回值均为 key 到具体组件的映射关系
 * 组件的类型有：list、add、edit、detail
 * 对于主资源，组件的 key 为 list、add、edit、detail
 * 对于嵌套资源和平行资源，组件的 key 为 name、nameAdd、nameEdit、nameDetail
 *
 * 使用 matchedComponentsMixin 来根据路由向页面中推入各种组件
 *
 * @constructor
 * @param {object} configs - VM configs
 */
import {matchedComponentsMixin} from './common/mixins/matchedCompoents'
import ParallelListViewFactory from './ParallelListView'
import ListViewFactory from './ListView/index'
import NestedListViewFactory from './NestedListView'
import decorateViewConfigs from '../utils/decorateViewConfigs'
import eventHub from '../utils/eventHub'
import routerKit from '../utils/routerKit'
import Tabs from '../components/Tabs'

export default function ViewFactory(configs) {
  decorateViewConfigs(configs)
return {
    name: 'BaseView',
    data() {
      return {
        viewInfo: {
          name: configs.data.name,
          hiddenKeys: [
            configs,
            ...(configs.nestedResource || []),
            ...(configs.parallelResource || [])
          ].reduce((prev, cur) => {
            for (const schema of cur.schema) {
              if (schema.type === 'hidden') {
                //TODO: label 和 key 都要存下
                if (prev[cur.data.name]) {
                  prev[cur.data.name].push(schema.key)
                } else {
                  prev[cur.data.name] = [schema.key]
                }
              }
            }
            return prev
          }, {})
        }
      }
    },
    methods: {
      switchViewMode(mode, data) {
        routerKit.current(this, mode, data, this.$router, this.$route)
      },
      openSubPage(name, mode, data) {
        routerKit.into(this, name, mode, data, this.$router, this.$route)
      },
      closeSubPage() {
        routerKit.back(this, this.$router, this.$route)
      }
    },
    created() {
      eventHub.$on('switchViewMode', this.switchViewMode)
      eventHub.$on('openSubPage', this.openSubPage)
      eventHub.$on('closeSubPage', this.closeSubPage)
    },
    beforeDestroy() {
      eventHub.$off('switchViewMode', this.switchViewMode)
      eventHub.$off('openSubPage', this.openSubPage)
      eventHub.$off('closeSubPage', this.closeSubPage)
    },
    render(h) {
      matchedComponentsMixin(this, configs)
      let allComponents = {}

      // fix error: check type before use length
      if (Array.isArray(configs.parallelResource) && configs.parallelResource.length) {
        allComponents = {
          ...allComponents,
          ...ParallelListViewFactory(configs.parallelResource)
        }
      }

      if (Array.isArray(configs.nestedResource) && configs.nestedResource.length) {
        allComponents = {
          ...allComponents,
          ...NestedListViewFactory(configs.nestedResource)
        }
      }

      const nestedViews = configs.nestedResource.map(r => allComponents[r.data.name])
      allComponents = {
        ...allComponents,
        ...ListViewFactory(configs, nestedViews)
      }

      const tabsChildren = []
      if (configs.tabs.length) {
        tabsChildren.push(<Tabs tabs={configs.tabs}></Tabs>)
      }
      const children = this.matchedComponents.map(item => h(allComponents[item]))
      return (
        <div>
          {tabsChildren.length > 0 ? <div class='sp-tabs'>{tabsChildren}</div> : null}
          <div>{children}</div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./packages/creator/index.js